export default (condition, objOrArr) => {
	const isArr = Array.isArray(objOrArr)
	const baseObj = isArr ? [] : {}
	return condition ? objOrArr : baseObj
}
